/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserRestCustomAttributeModel } from './userRestCustomAttributeModel';
import { UserRoles } from './userRoles';


export interface UserRestCreateModel { 
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    userType?: UserRoles;
    phone?: string | null;
    mobile?: string | null;
    fax?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    postalCode?: string | null;
    poBox?: string | null;
    state?: string | null;
    employeeNumber?: string | null;
    department?: string | null;
    jobTitle?: string | null;
    employmentType?: string | null;
    country?: string | null;
    isLocked?: boolean;
    isEnabled?: boolean;
    aliases?: Array<string> | null;
    customAttributes?: Array<UserRestCustomAttributeModel> | null;
    autoGeneratePassword?: boolean;
    password?: string | null;
    mustChangePasswordOnLogin?: boolean;
    sendEmail?: boolean;
    username: string;
    email: string;
}

